/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedIconBubbleEmail_item$ref = any;
export type PdpSharedIconBubbleEmail_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly photos: ReadonlyArray<{
        readonly largePath: string | null;
    } | null> | null;
    readonly " $refType": PdpSharedIconBubbleEmail_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedIconBubbleEmail_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "photos",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemPhoto",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "largePath",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'e8fbfcc195212d17be55488294e78803';
export default node;
